import { mdiBookmarkMultiple, mdiFrequentlyAskedQuestions } from "@mdi/js";
import { Group } from "~/components/ui/group";
import { Icon } from "~/components/ui/icon";
import { TabsTrigger } from "~/components/ui/tabs";

export function FaqSidebarTabs() {

	return (
		<Group class="mb-6">
			<TabsTrigger
				class="w-full py-2"
				value="toc"
				variant="filled"
			>
				Overzicht
				<Icon path={mdiFrequentlyAskedQuestions} class="ml-2" />
			</TabsTrigger>
			<TabsTrigger
				class="w-full py-2"
				value="bookmarks"
				variant="filled"
			>
				Bladwijzers
				<Icon path={mdiBookmarkMultiple} class="ml-2" />
			</TabsTrigger>
		</Group>
	);
}